<template>
  <vue-recaptcha
    :sitekey="keyRecaptcha"
    @verify="onVerify"
    @error="onRecaptchaError"
    size="invisible"
    @expired="onExpired"
    @render="onRender"
    :load-recaptcha-script="true"
    recaptcha-host="www.recaptcha.net"
    ref="recaptcha"
    class="demo-recaptcha"
  />
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Config from '@/config'

export default {
  components: {
    VueRecaptcha,
  },
  created() {
    this.keyRecaptcha = Config.keyRecapcha
  },

  methods: {
    execute() {
      this.$refs.recaptcha.execute()
    },
    onVerify(response) {
      this.$emit('success', response)
    },
    onRender() {
      this.$emit('render')
    },
    onExpired() {
      this.$refs.recaptcha.reset()
    },
    onRecaptchaError() {
      this.$emit('error')
    },
  },
}
</script>
